import React, { Fragment, useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from "@material-ui/core/styles";
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Activity from './Activity';
import { SESSION_STORAGE_COVR_FULLUW_KEY, SESSION_STORAGE_BASIC_INFO_KEY } from '../../sessionStorage';

export default function Account(props) {

  if (props.location && props.location.pathname.split("/").pop() === 'ns') {
    //clear product session
    sessionStorage.removeItem(SESSION_STORAGE_COVR_FULLUW_KEY);
    sessionStorage.removeItem(SESSION_STORAGE_BASIC_INFO_KEY);
  }

  const [caseStatusList, setCaseStatusList] = useState(null);
  const [inProgressAppsList, setInProgressAppsList] = useState(null);

  const { path } = useParams();
  const TAB_ACTIVITY = 0;
  const TAB_POLICIES = 1;
  const TAB_MY_COVR_STORY = 2;
  const TAB_PROFILE = 3;

  const getTabIndex = (path) => {
    let tabIndex = TAB_ACTIVITY;
    switch (path) {
      case 'activity':
        tabIndex = TAB_ACTIVITY;
        break;
      case 'policies':
        tabIndex = TAB_POLICIES;
        break;
      case 'my-covr-story':
        tabIndex = TAB_MY_COVR_STORY;
        break;
      case 'profile':
        tabIndex = TAB_PROFILE;
        break;
    }

    return tabIndex;
  }

  //const getPathNameFromTabIndex = (tabIndex) => {
  //  let pathName = 'activity';
  //  switch (tabIndex) {
  //    case TAB_ACTIVITY:
  //      pathName = 'activity';
  //      break;
  //    case TAB_POLICIES:
  //      pathName = 'policies';
  //      break;
  //    case TAB_MY_COVR_STORY:
  //      pathName = 'my-covr-story';
  //      break;
  //    case TAB_PROFILE:
  //      pathName = 'profile';
  //      break;
  //  }

  //  return pathName
  //}

  const currentTab = getTabIndex(path);

  //const handleTabChange = (newTabIndex) => {
  //  props.history.push(`/account/${getPathNameFromTabIndex(newTabIndex)}`)
  //};

  const useStyles = makeStyles(theme => ({
    panelContainer: {
      'backgroundColor': '#F2F2F2',
      'paddingTop': '2rem',
      'paddingBottom': '2rem',
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    fetch('/api/CaseStatus/List', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then(res => res.json())
      .then(json => {
        setCaseStatusList(json.SubmittedApps);

        setInProgressAppsList(json.InProgressApps);
      });
    
  }, []);

  return (
    <div>
      <AppBar position="static">
        <Container>
          <Tabs value={currentTab} aria-label="tabs" variant="scrollable" scrollButtons="off">
            <Tab component={Link} to="/account/activity" label="Activity" id="account-tab-0" />
            {/*<Tab component={Link} to="/account/policies" label="Policies" id="account-tab-1" />
            <Tab component={Link} to="/account/my-covr-story" label="My Covr Story" id="account-tab-2" />
            <Tab component={Link} to="/account/profile" label="Profile" id="account-tab-3" />*/}
          </Tabs>
        </Container>
      </AppBar>

      <div className={classes.panelContainer}>
        <TabPanel value={currentTab} index={TAB_ACTIVITY}>
          <Activity caseStatusList={caseStatusList} inProgressAppsList={inProgressAppsList} history={props.history} />
        </TabPanel>

        <TabPanel value={currentTab} index={TAB_POLICIES}>
          <div>policies</div>
        </TabPanel>

        <TabPanel value={currentTab} index={TAB_MY_COVR_STORY}>
          <div>My Covr Story</div>
        </TabPanel>

        <TabPanel value={currentTab} index={TAB_PROFILE}>
          <div>Profile</div>
        </TabPanel>
      </div>
    </div>
  )
}

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`account-tabpanel-${index}`}
      aria-labelledby={`account-tab-${index}`}
    >
      {value === index && (
        <Fragment>{children}</Fragment>
      )}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/Account/Account.js